<div
    class="flex flex-col text-lightMode-800 dark:text-darkMode-100 bg-lightCardBG dark:bg-darkCardBG min-w-[15rem]">
    <div class="w-full p-8 flex items-center">
        <mat-icon aria-hidden="true" data-mat-icon-type="font"
            class="size-auto text-yellow-500 flex items-center justify-center rtl:ml-2 ltr:mr-2 text-5xl">
            report
        </mat-icon>
        ابتدا باید وارد اکانت خود شوید!
    </div>
    <div class="flex px-5 py-3 bg-lightMode-200 dark:bg-darkMode-700 w-full">
        <a matRipple matDialogClose (click)="navigateToLoginUrl()"
            class="bg-blue-500 px-3 py-2 h-[40px] min-w-[70px] rounded-md text-white text-center flex items-center justify-center cursor-pointer">
            ورود
        </a>
        <button matRipple matDialogClose
            class="mx-3 px-3 py-2 h-[40px] min-w-[70px] rounded-md bg-lightMode-100 dark:bg-darkMode-800 text-lightMode-800 dark:text-darkMode-100 text-center flex items-center justify-center">
            انصراف
        </button>
    </div>
</div>
